var exports = {
  "i": "xaee3c4fa--eb79d8--wrapper",
};

module.exports = exports;
